// these values should match "login type" https://github.com/alltrails/alltrails_analytics_definition/blob/main/analytics.json
export const APPLE = 'apple';
export const EMAIL = 'email';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';
export const GOOGLE_ONE_TAP = 'google one tap';
